import { useEffect, useState } from 'react';

import { useUserAssets } from 'src/hooks/use-user-assets.hook';
import authService from 'src/services/api/auth.service';
import { hasMClassEntitlement } from 'src/services/entitlement.service';

export const useIsMClassUserCheck = () => {
  const tokenParsed = authService.getParsedToken();
  const mclassUserSid = tokenParsed.mclassUserSid;

  const [isMClassUser, setIsMClassUser] = useState<null | boolean>(null);

  const { data: userAssets, isLoadingWithoutError: isLoading } =
    useUserAssets();

  useEffect(() => {
    if (!userAssets) return;

    setIsMClassUser(hasMClassEntitlement(userAssets));
  }, [userAssets]);

  return { isMClassUser: !!mclassUserSid || isMClassUser, isLoading };
};
